import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as payment from '@webapp/sdk/payment';
import { Actions } from '../../actions';
import {
  GetPaymentMethods,
  GetPaymentMethodsSuccess,
  GetPaymentMethodsError,
} from '../action-creators';
import { GET_PAYMENT_METHODS } from '../actions';

export const getPaymentMethodsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetPaymentMethods>(GET_PAYMENT_METHODS),
    mergeMap(async (action) => {
      try {
        const list = await payment.listPaymentMethods(action.ownerId);

        return new GetPaymentMethodsSuccess(action.ownerId, list);
      } catch (err) {
        return new GetPaymentMethodsError(err.message);
      }
    })
  );
